import { parseScheduledDate } from "./assessmentCalendarRules";

export function formatCalendarShortDate(value) {
  const date = value instanceof Date ? value : parseScheduledDate(value);
  if (!date) return "";
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}

export function formatCalendarLocation(row) {
  const parts = [row?.provider_city, row?.provider_state, row?.provider_country].filter(Boolean);
  return parts.length ? parts.join(", ") : "Location unavailable";
}

export function formatOnsiteRemote(vqaType) {
  const normalized = String(vqaType || "").toLowerCase();
  if (normalized.includes("remote")) return "Remote";
  if (normalized.includes("onsite") || normalized.includes("on-site")) return "On-Site";
  return vqaType || "—";
}

const RELEASED_STATUSES = new Set([
  "Final Report",
  "Final Report Delivered",
  "Report Anonymized",
  "Report Published to Library",
]);

export function resolveProviderDisplayName(row) {
  return (
    row?.provider_name ||
    row?.provider ||
    row?.name ||
    row?.vendor_name ||
    "Unknown vendor"
  );
}

export function resolveSponsorDisplayName(row) {
  const name =
    row?.sponsor_name ||
    row?.sponsor ||
    row?.organization_name ||
    row?.sponsor_organization_name ||
    "";
  return String(name).trim();
}

export function formatRequestScheduleLine(row, { showAuditor = false } = {}) {
  // The date this row's sponsor submitted its request (initial or join), not when the VQA was created.
  const requested =
    formatCalendarShortDate(row?.sponsor_request_created_on ?? row?.vqa_created_on) || "--";
  const scheduled = formatCalendarShortDate(row?.assessment_start_date) || "--";
  const parts = [`Requested ${requested}`, `Scheduled ${scheduled}`];
  const release = formatCalendarShortDate(row?.vqa_report_released_on);
  const status = row?.vqa_status;
  if (release && status && RELEASED_STATUSES.has(status)) {
    parts.push(`Released ${release}`);
  }
  if (showAuditor) {
    const auditor = (row?.vqa_auditor_name || "").trim() || "Unassigned";
    parts.push(auditor);
  }
  return parts.join(" | ");
}

export function providerInitial(name) {
  const trimmed = String(name || "").trim();
  return trimmed ? trimmed.charAt(0).toUpperCase() : "?";
}

export function capabilityNames(row) {
  return (row?.capabilities || []).map((item) => item?.rfi_name).filter(Boolean);
}

export function mapCapabilitiesForScope(row) {
  return capabilityNames(row).map((name) => ({ rfi_name: name }));
}
